import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { Download, Printer, Copy, QrCode } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';

// The .env key is not carried into production builds, so fall back to the domain the admin is using.
const SIGNUP_URL = `${process.env.REACT_APP_PUBLIC_SITE_URL || window.location.origin}/register`;
const MINT = '#00D9A5';
const DARK = '#1A1A1A';

const buildPosterCanvas = (qrCanvas) => {
  const width = 1200;
  const height = 1500;
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#FFFFFF';
  ctx.fillRect(0, 0, width, height);
  ctx.fillStyle = MINT;
  ctx.fillRect(0, 0, width, 24);
  ctx.textAlign = 'center';
  ctx.fillStyle = DARK;
  ctx.font = 'bold 96px Arial, sans-serif';
  ctx.fillText('TugGo', width / 2, 170);
  ctx.font = 'bold 56px Arial, sans-serif';
  ctx.fillText('Registe-se já', width / 2, 270);
  ctx.fillStyle = '#555555';
  ctx.font = '40px Arial, sans-serif';
  ctx.fillText('Clientes e Estafetas — aponte a câmara do telemóvel', width / 2, 340);
  ctx.drawImage(qrCanvas, (width - 900) / 2, 410, 900, 900);
  ctx.fillStyle = DARK;
  ctx.font = 'bold 44px Arial, sans-serif';
  ctx.fillText(SIGNUP_URL.replace(/^https?:\/\//, ''), width / 2, 1400);
  return canvas;
};

export const SignupQrCode = () => {
  const qrRef = useRef(null);

  const downloadPng = () => {
    const link = document.createElement('a');
    link.href = buildPosterCanvas(qrRef.current).toDataURL('image/png');
    link.download = 'tuggo-qrcode-registo.png';
    link.click();
  };

  const printPoster = () => {
    const image = buildPosterCanvas(qrRef.current).toDataURL('image/png');
    const win = window.open('', '_blank');
    if (!win) {
      toast.error('Permita janelas pop-up para imprimir o cartaz');
      return;
    }
    win.document.write(`<html><head><title>TugGo - QR Code de Registo</title><style>@page{size:A4;margin:12mm}body{margin:0;display:flex;justify-content:center}img{width:100%;max-width:180mm}</style></head><body><img src="${image}" onload="window.print()" /></body></html>`);
    win.document.close();
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(SIGNUP_URL);
      toast.success('Link copiado');
    } catch (err) {
      toast.error('Não foi possível copiar o link');
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-8 max-w-3xl" data-testid="signup-qrcode-section">
      <div className="flex items-center gap-2 mb-2">
        <QrCode className="w-6 h-6 text-tuggo-mint" />
        <h2 className="text-xl font-bold text-gray-900">QR Code de Registo</h2>
      </div>
      <p className="text-gray-600 mb-8">
        Clientes e estafetas leem este código com o telemóvel e abrem diretamente a página de registo, onde escolhem o tipo de conta.
      </p>
      <div className="flex flex-col md:flex-row gap-8 items-center md:items-start">
        <div className="p-4 border-2 border-tuggo-mint rounded-2xl bg-white" data-testid="signup-qrcode">
          <QRCodeCanvas value={SIGNUP_URL} size={240} level="H" marginSize={2} fgColor={DARK} bgColor="#FFFFFF" />
          <QRCodeCanvas ref={qrRef} value={SIGNUP_URL} size={900} level="H" marginSize={2} fgColor={DARK} bgColor="#FFFFFF" style={{ display: 'none' }} />
        </div>
        <div className="flex-1 space-y-4 w-full">
          <div>
            <div className="text-xs uppercase tracking-wide text-gray-500 mb-1">Endereço do QR Code</div>
            <div className="font-mono text-sm bg-gray-50 border rounded-lg px-3 py-2 break-all" data-testid="signup-qrcode-url">{SIGNUP_URL}</div>
          </div>
          <div className="flex flex-wrap gap-3">
            <Button onClick={downloadPng} className="bg-tuggo-mint hover:bg-tuggo-mint-dark text-white rounded-full" data-testid="signup-qrcode-download-btn">
              <Download className="w-4 h-4 mr-2" /> Descarregar PNG
            </Button>
            <Button onClick={printPoster} variant="outline" className="rounded-full" data-testid="signup-qrcode-print-btn">
              <Printer className="w-4 h-4 mr-2" /> Imprimir cartaz
            </Button>
            <Button onClick={copyLink} variant="outline" className="rounded-full" data-testid="signup-qrcode-copy-btn">
              <Copy className="w-4 h-4 mr-2" /> Copiar link
            </Button>
          </div>
          <p className="text-xs text-gray-500">O PNG e o cartaz incluem o nome TugGo, o QR Code e o endereço, prontos para panfletos, viaturas ou montras.</p>
        </div>
      </div>
    </div>
  );
};
